import Vue from 'vue';
import VueRouter from "vue-router";
// import VueGtag from "vue-gtag";
import activity from "@/functions/activityLog.js";
import checkBranch from "@/functions/checkGroupBranch";
import gb_etaxrolelevel from "@/functions/etaxrolelevel";
import VueGtm from "vue-gtm";
import store from '../store';

const landingpage_index = () => import('@/components/landingpages/pages/landing-page-index')
const landingpage_shareholder = () => import('@/components/landingpages/pages/landing-page-shareholder')
const landingpage_attention = () => import('@/components/landingpages/pages/landing-page-attention')
const landingpage_usermanual = () => import('@/components/landingpages/pages/landing-page-usermanual')
const landingpage_404 = () => import('@/components/landingpages/pages/landing-page-404')

const landingpage_seminar = () => import('@/components/landingpages/pages/landing-page-specialevent-register')

const webportal_index = () => import('@/components/webportals/pages/web-portal-index')
const webportal_login = () => import('@/components/webportals/pages/web-portal-login')

const webportal_dashboard = () => import('@/components/webportals/pages/etax/web-portal-dashboard')
const webportal_report = () => import('@/components/webportals/pages/etax/web-portal-report')
const webportal_reportsetting = () => import('@/components/webportals/pages/etax/web-portal-reportsetting')
const webportal_searchdocument = () => import('@/components/webportals/pages/etax/web-portal-searchdocuments')
const webportal_reportinstead = () => import('@/components/webportals/pages/etax/web-portal-report-instead.vue')
const webportal_processlog = () => import('@/components/webportals/pages/etax/web-portal-processlog.vue')
const webportal_mailrelayreport = () => import('@/components/webportals/pages/etax/web-portal-mailrelayreport.vue')
const webportal_customeremail = () => import('@/components/webportals/pages/etax/web-portal-customeremail.vue')
const webportal_resendmail = () => import('@/components/webportals/pages/etax/web-portal-resendmail.vue')
const profile = () => import('@/components/webportals/pages/profile/profile.vue')
const web_portal_searchRevenue = () => import('@/components/webportals/pages/etax/web-portal-searchRevenue')
const web_portal_Revenue_status = () => import('@/components/webportals/pages/etax/web-portal-searchRevenue_status')
const web_portal_delete_transaction = () => import('@/components/webportals/pages/etax/web-portal-deleteTransaction')
const web_confirm = () => import('@/components/webportals/pages/etax/web-confirm')
const webportal_mailrelayreport_V2 = () => import('@/components/webportals/pages/etax/web-portal-mailrelayreport-V2.vue')

const webportal_logs_system_usage = () => import('@/components/webportals/pages/etax/web-portal-logsSystemUsage.vue')
const webportal_logs_print_document = () => import('@/components/webportals/pages/etax/web-portal-logsPrintDocument.vue')
const web_portal_Revenue_byone = () => import("@/components/webportals/pages/etax/web-portal-searchRevenue_byOne");


const webportal_bill_index_etax = () => import('@/components/webportals/pages/bill/e-tax/portal-create-bill-index.vue')
const webportal_bill_add_etax = () => import('@/components/webportals/pages/bill/e-tax/portal-create-bill-add.vue')
const webportal_bill_edit_etax = () => import('@/components/webportals/pages/bill/e-tax/portal-create-bill-edit.vue')
const webportal_bill_view_etax = () => import('@/components/webportals/pages/bill/e-tax/portal-create-bill-view.vue')

const webportal_running_number_index = () => import('@/components/webportals/pages/bill/web-portal-running-number-index.vue')
const webportal_running_number_add = () => import('@/components/webportals/pages/bill/web-portal-running-number-add.vue')
const webportal_running_number_edit = () => import('@/components/webportals/pages/bill/web-portal-running-number-edit.vue')

const webportal_edit_tex_invoice = () => import("@/components/webportals/pages/bill/web-portal-edit-tax-invoice.vue");
const webportal_cancle_document_etax = () => import("@/components/webportals/pages/bill/web-portal-cancle-document.vue");
const webportal_detail_cancle_document_some = () => import("@/components/webportals/pages/bill/canle-document-etax/detail.vue");

const webportal_searchdocument_abb = () => import('@/components/webportals/pages/etax-abb/web-portal-searchdocuments-abb')
const webportal_dashboard_abb = () => import('@/components/webportals/pages/etax-abb/web-portal-dashboard-abb')
const webportal_report_abb = () => import('@/components/webportals/pages/etax-abb/web-portal-report-abb')
const webportal_reportsetting_abb = () => import('@/components/webportals/pages/etax-abb/web-portal-reportsetting-abb')


const webportal_sftp_login = () => import('@/components/webportals/pages/sftp/login.vue')
const webportal_sftp_register = () => import('@/components/webportals/pages/sftp/register.vue')
const webportal_sftp = () => import('@/components/webportals/pages/sftp/web-portal-sftp-ftp.vue')
const webportal_sftp_dir = () => import('@/components/webportals/pages/sftp/web-portal-sftp-ftp-directory.vue')

const webportal_create_po = () => import("@/components/webportals/pages/po/web-portal-createPO.vue");
const webportal_othr = () => import("@/components/webportals/pages/po/web-portal-othr.vue");
const webportal_po_kbank = () => import("@/components/webportals/pages/po/kbank.vue");
const webportal_openApi_create_etax = () => import("@/components/webportals/pages/openAPI/web-portal-create-etax.vue");
const webportal_setting_license = () => import("@/components/webportals/pages/etax/web-portal-setting-license.vue");

const webportal_group_user = () => import("@/components/webportals/pages/setting-group/web-portal-group-user.vue");
const webportal_userManual = () => import("@/components/webportals/pages/etax/web-portal-usermanual.vue");

const webportal_nextcapital_index = () => import("@/components/webportals/pages/nextcapital/index.vue");
const webportal_nextcapital_preview = () => import("@/components/webportals/pages/nextcapital/preview.vue");
const webportal_nextcapital_detail = () => import("@/components/webportals/pages/nextcapital/detail.vue");

const webportal_efact_sso = () => import("@/components/webportals/pages/efact/sso.vue");

const webportal_login_sso = () => import("@/components/webportals/pages/sso/login.vue");

// taxbox
const webportal_index_taxbox = () => import("@/components/webportals/pages/taxbox/index.vue");
const webportal_detail_taxbox = () => import("@/components/webportals/pages/taxbox/detail.vue");
const webportal_preview_taxbox = () => import("@/components/webportals/pages/taxbox/preview.vue");

const webportal_cutsat = () =>
  import("@/components/webportals/pages/satisfaction.vue");
const webportal_customize_normal = () =>
  import("@/components/webportals/pages/customize/normal.vue");
const webportal_customize_group = () =>
  import("@/components/webportals/pages/customize/group.vue");
const webportal_flowaccount_login = () =>
  import("@/components/webportals/pages/flowaccount/web-portal-flowaccount-login.vue");
const webportal_flowaccount_index = () =>
  import("@/components/webportals/pages/flowaccount/web-portal-flowaccount-index.vue");


// import gb_etaxtaxidaccess from "@/functions/checkTaxIDAccess.js";
Vue.use(VueRouter);



const logout = (to, from, next) => {
  if (store.getters.authen === true) {
    store.dispatch('AUTH_PORTAL_EXPIRED')
      .then(
        localStorage.removeItem('Access'),
        localStorage.removeItem('STID'),
        localStorage.removeItem('SERVICEMAIL'),
        localStorage.removeItem('SELLERID'),
        localStorage.removeItem('Username'),
        localStorage.removeItem('SFTPUSERNAME'),
        localStorage.removeItem('SFTPLOGIN'),
        localStorage.removeItem('SFTPPROFILE'),
        localStorage.removeItem('LoginFail'),
        Vue.$cookies.remove("Access"),
        Vue.$cookies.remove("Username"),
        Vue.$cookies.remove("STID"),
        Vue.$cookies.remove("refreshtoken_package"),
        store.dispatch("setMenu", []),
        store.dispatch("setGroupServiceh", null),
        next('/portal/login')
      )
      .catch((error) => {
        console.log(error.response)
      })
  } else {
    store.dispatch("setMenu", [])
    store.dispatch("setGroupServiceh", null),
      store.dispatch('AUTH_PORTAL_EXPIRED')
    localStorage.removeItem('Access'),
      localStorage.removeItem('STID'),
      localStorage.removeItem('SERVICEMAIL'),
      localStorage.removeItem('SELLERID'),
      localStorage.removeItem('Username'),
      localStorage.removeItem('SFTPUSERNAME'),
      localStorage.removeItem('SFTPLOGIN'),
      localStorage.removeItem('SFTPPROFILE'),
      localStorage.removeItem('LoginFail'),
      Vue.$cookies.remove("Access")
    Vue.$cookies.remove("Username")
    Vue.$cookies.remove("STID")
    Vue.$cookies.remove("refreshtoken_package")
  }
  next('/portal/login')
}

const checkAuthMenu = async (to) => {
  let accessTaxid = await gb_etaxrolelevel.checkTaxid(to);
  let accessRole = await gb_etaxrolelevel.checkRoleAccess(to)
  let activeRole = await gb_etaxrolelevel.checkRoleActiveMenu(store.getters.profile.role)
  if (accessRole.includes(activeRole.role_name) === true && accessTaxid === true) {
    return true
  } else {
    return false
  }
  // return true
}

const ifAuthenticated = async (to, from, next) => {
  if (Vue.$cookies.isKey("Access") == true) {
    if (store.getters.authen === true) {
      checkBranch.checkGroup();
      await gb_etaxrolelevel.setMenu();
      let activeRole = gb_etaxrolelevel.checkRoleActiveMenu(store.getters.profile.role)
      if (to.meta.role_access.includes(activeRole.role_name) === true) {
        next()
        return
      } else {
        next('/portal')
        return
      }
    } else {
      store.dispatch('AUTH_PORTAL_CHECK').then(async response => {
        if (response.status === 'success') {
          checkBranch.checkGroup();
          await gb_etaxrolelevel.setMenu();
          let activeRole = gb_etaxrolelevel.checkRoleActiveMenu(store.getters.profile.role)
          if (to.meta.role_access.includes(activeRole.role_name) === true) {
            next()
            return
          } else {
            next('/portal')
            return
          }
        } else {
          next('/portal/login')
          return
        }
      })
    }
  } else {
    store.dispatch('AUTH_PORTAL_EXPIRED')
    localStorage.clear()
    next('/portal/login')
  }
}

const ifAuthenticatedNew = async (to, from, next) => {
  activity.log(to);
  if (Vue.$cookies.isKey("Access") == true) {
    if (store.getters.authen === true) {
      checkBranch.checkGroup();
      const authMenu = await checkAuthMenu(to)
      if (authMenu === true) {
        next()
      } else {
        next('/portal/profile')
      }
      return;
    } else {
      store.dispatch('AUTH_PORTAL_CHECK').then(async response => {
        if (response.status === 'success') {
          checkBranch.checkGroup();
          const authMenu = await checkAuthMenu(to)
          if (authMenu === true) {
            next()
          } else {
            next('/portal/profile')
          }
          return;
        } else {
          store.dispatch("setMenu", [])
          store.dispatch("setGroupServiceh", null),
            next("/portal/login");
        }
      });
    }
  } else {
    store.dispatch("AUTH_PORTAL_EXPIRED");
    localStorage.clear();
    store.dispatch("setMenu", [])
    store.dispatch("setGroupServiceh", null),
      next("/portal/login");
  }
};

const ifAuthenticatedSFTP = async (to, from, next) => {
  if (store.getters.authen === true) {
    const authMenu = await checkAuthMenu(to)
    if (localStorage.getItem("SFTPLOGIN")) {
      if (authMenu === true) {
        next()
      } else {
        next('/portal/sftp-ftp/login')
      }
      return
    } else {
      next('/portal/sftp-ftp/login')
    }
  } else {
    store.dispatch('AUTH_PORTAL_CHECK').then(async (response) => {
      if (response.status === 'success') {
        const authMenu = await checkAuthMenu(to)
        if (localStorage.getItem("SFTPLOGIN")) {
          if (authMenu === true) {
            next()
          } else {
            next('/portal/sftp-ftp/login')
          }
          return
        } else {
          store.dispatch("setMenu", [])
          store.dispatch("setGroupServiceh", null),
            next('/portal/sftp-ftp/login')
        }
      } else {
        store.dispatch("setMenu", [])
        store.dispatch("setGroupServiceh", null),
          next('/portal/login')
      }
    })
  }
}


const router = new VueRouter({
  base: '/',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      name: 'wildcard',
      redirect: '/Notfound'
    },
    {
      path: '/',
      name: 'HelloWorld',
      redirect: "/portal/login"
    },
    {
      path: '/Notfound',
      name: 'landingpage_404',
      component: landingpage_404
    },
    {
      path: '/portal/web_confirm/:param',
      name: 'web_confirm',
      component: web_confirm
    },
    {
      path: '/Attention',
      name: 'landingpage_attention',
      component: landingpage_seminar
    },
    {
      path: '/ContactToEtax',
      name: 'landingpage_attention',
      component: landingpage_attention
    },
    {
      path: '/Shareholder',
      name: 'landingpage_shareholder',
      component: landingpage_shareholder
    },
    {
      path: '/Usermanual',
      name: 'landingpage_usermanual',
      component: landingpage_usermanual
    },
    {
      path: "/request_service_express",
      name: "webportal_create_po",
      component: webportal_create_po,
    },
    {
      path: "/po-kbank",
      name: "webportal_po_kbank",
      component: webportal_po_kbank,
    },
    {
      path: "/portal/login_sso",
      name: "login_sso",
      component: webportal_login_sso,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/request_service_othr",
      name: "webportal_othr",
      component: webportal_othr,
    },
    {
      path: "/portal/usermanual",
      name: "webportal_userManual",
      component: webportal_userManual,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/index',
      name: 'index',
      component: webportal_index,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal',
      name: '',
      component: webportal_index,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/satisfaction',
      name: 'cutsat',
      component: webportal_cutsat,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/login',
      name: 'webportal_login',
      component: webportal_login
    },
    {
      path: '/portal/dashboard',
      name: 'dashboard',
      component: webportal_dashboard,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/report',
      name: 'report',
      component: webportal_report,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/reportsetting',
      name: 'reportsetting',
      component: webportal_reportsetting,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/searchdocument',
      name: 'searchdocument',
      component: webportal_searchdocument,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/reportinstead',
      name: 'reportinstead',
      component: webportal_reportinstead,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/processlog',
      name: 'processlog',
      component: webportal_processlog,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    // {
    //   path: '/portal/generateinvoicebypdf',
    //   name: 'webportal_generateinvoicebypdf',
    //   component: webportal_generateinvoicebypdf,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/portal/mailrelayreport',
      name: 'mailrelayreport',
      component: webportal_mailrelayreport,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/mailrelayreport_v2',
      name: 'mailrelayreport',
      component: webportal_mailrelayreport_V2,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/resendmail',
      name: 'mailrelayreport',
      component: webportal_resendmail,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/customeremail',
      name: 'mailrelayreport',
      component: webportal_customeremail,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/profile',
      name: 'profile',
      component: profile,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/web_portal_searchRevenue',
      name: 'searchRevenue',
      component: web_portal_searchRevenue,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user"] }
    },
    {
      path: '/portal/web_portal_Revenue_status',
      name: 'statusRevenue',
      component: web_portal_Revenue_status,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user"] }
    },
    {
      path: '/portal/logout',
      name: 'logout',
      beforeEnter: logout
    },
    {
      path: '/portal/searchdocumentabb',
      name: 'searchdocumentabb',
      component: webportal_searchdocument_abb,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/dashboardabb',
      name: 'dashboardabb',
      component: webportal_dashboard_abb,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/reportabb',
      name: 'reportabb',
      component: webportal_report_abb,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/reportsettingabb',
      name: 'reportsettingabb',
      component: webportal_reportsetting_abb,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/delete_transaction',
      name: 'deleteTransaction',
      component: web_portal_delete_transaction,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/logs_system_usage',
      name: 'logsSystemUsage',
      component: webportal_logs_system_usage,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin"] }
    },
    {
      path: '/portal/logs_print_document',
      name: 'logsPrintDocument',
      component: webportal_logs_print_document,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin"] }
    },
    {
      path: '/portal/create_bill_index',
      name: 'bill',
      component: webportal_bill_index_etax,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/create_bill_add',
      name: 'bill',
      component: webportal_bill_add_etax,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/create_bill_edit',
      name: 'bill',
      component: webportal_bill_edit_etax,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/create_bill_view',
      name: 'bill',
      component: webportal_bill_view_etax,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/sftp-ftp/login',
      name: 'sftp',
      component: webportal_sftp_login,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/sftp-ftp/register',
      name: 'sftp',
      component: webportal_sftp_register,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/sftp-ftp',
      name: 'webportal_sftp',
      component: webportal_sftp,
      beforeEnter: ifAuthenticatedSFTP,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/sftp-ftp/:id',
      name: 'webportal_sftp_dir',
      component: webportal_sftp_dir,
      beforeEnter: ifAuthenticatedSFTP,
      props: true,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/running_number_index',
      name: 'runningNumber',
      component: webportal_running_number_index,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/running_number_add',
      name: 'runningNumber',
      component: webportal_running_number_add,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: '/portal/running_number_edit',
      name: 'runningNumber',
      component: webportal_running_number_edit,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/cancle_document_etax",
      name: "cancleDocument",
      component: webportal_cancle_document_etax,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/edit_cancel_document",
      name: "editTaxInvoice",
      component: webportal_edit_tex_invoice,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/open-api-create-etax",
      name: "open_api_create_etax",
      component: webportal_openApi_create_etax,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/setting-license",
      name: "setting-license",
      component: webportal_setting_license,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin"] }
    },
    {
      path: "/portal/group-user",
      name: "group-user",
      component: webportal_group_user,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin"] }
    },
    {
      path: '/portal/web_portal_Revenue_byone',
      name: 'revenueByone',
      component: web_portal_Revenue_byone,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/sftp_confirm_index",
      name: "sftp_confirm",
      component: webportal_nextcapital_index,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/sftp_confirm_preview",
      name: "sftp_confirm",
      component: webportal_nextcapital_preview,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/sftp_confirm_detail",
      name: "sftp_confirm",
      component: webportal_nextcapital_detail,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/efact_sso",
      name: "profile",
      component: webportal_efact_sso,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/taxbox_index",
      name: "taxbox",
      component: webportal_index_taxbox,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/taxbox_detail",
      name: "taxbox",
      component: webportal_detail_taxbox,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/taxbox_preview",
      name: "taxbox",
      component: webportal_preview_taxbox,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/cancle_document_some_detail",
      name: "bill",
      component: webportal_detail_cancle_document_some,
      beforeEnter: ifAuthenticatedNew,
      meta: { role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"] }
    },
    {
      path: "/portal/customize",
      name: "customize",
      component: webportal_customize_normal,
       beforeEnter: ifAuthenticatedNew,
      meta: {
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"]
      }
    },
    {
      path: "/portal/customize_by_id",
      name: "customize_by_id",
      component: webportal_customize_group,
       beforeEnter: ifAuthenticatedNew,
      meta: {
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"]
      }
    },
    {
      path: "/portal/flow-account",
      name: "flow_account",
      component: webportal_flowaccount_login,
      beforeEnter: ifAuthenticatedNew,
      meta: {
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"]
      }
    },
    {
      path: "/portal/flow-account/index",
      name: "flow_account",
      component: webportal_flowaccount_index,
      beforeEnter: ifAuthenticatedNew,
      meta: {
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"]
      }
    },
  ]
})
// Enable Google Analytics
Vue.use(
  // VueGtag,
  // {
  //   config: {
  //     // enabled: process.env.NODE_ENV === "production",
  //     enabled: true,
  //     id: "G-MNXW0TQVLQ",
  //   },
  //   pageTrackerExcludedRoutes: [
  //     'route_path_value', 
  //     'route_name_value'
  //   ],
  //   appName: "etax.one.th",
  //   pageTrackerScreenviewEnabled: true,
  // },
  // router
  VueGtm, {
  id: "GTM-WZ3FJX6", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: false, // defaults to false. Script can be set to defer to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
}
);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js